export default class OutlineConfig {
    constructor(_config) {
        this.layers = [

            //Congress outline
            {
                id: `${_config.enums.LEG_BODY.CONGRESS}-outline`,
                type: 'line',
                'source': `${_config.enums.LEG_BODY.CONGRESS}-choro-source`,
                //'source': `legislative-choro-source`,
                'source-layer': `congress_demographics`,
                paint: {
                    'line-color': '#fff', //707070  222
                    'line-opacity': 0.8, //1
                    'line-width': 1.25 //.5
                },
                'layout': {
                    'visibility': 'visible',
                },
                'minzoom': 6,
                'params':{
                    beforeId: 'choropleth-outline-placeholder'
                }
            },
            //Congress highlight outline
            {
                id: `${_config.enums.LEG_BODY.CONGRESS}-highlight-outline`,
                type: 'line',
                'source': `${_config.enums.LEG_BODY.CONGRESS}-choro-source`,
                //'source': `legislative-choro-source`,
                'source-layer': `congress_demographics`,
                paint: {
                    'line-color': '#222',
                    'line-opacity': 1,
                    'line-width': 5
                },
                'layout': {
                    'visibility': 'visible',
                },
                //https://docs.mapbox.com/mapbox-gl-js/style-spec/expressions/
                //https://docs.mapbox.com/help/glossary/filter/
                "filter": ["==", ["get","geoid"], -1],
                'params':{
                    beforeId: 'choropleth-highlight-outline-placeholder',
                }
            },
            //St Upper outline
            {
                id: `${_config.enums.LEG_BODY.ST_UPPER}-outline`,
                type: 'line',
                'source': `${_config.enums.LEG_BODY.ST_UPPER}-choro-source`,
                //'source': `legislative-choro-source`,
                'source-layer': `statelegupper_demographics`,
                paint: {
                    'line-color': '#fff', //241 707070  222
                    'line-opacity': 0.8, //1
                    'line-width': 1.25 //.5
                },
                'layout': {
                    'visibility': 'none',
                },
                'minzoom': 6,
                'params':{
                    beforeId: 'choropleth-outline-placeholder',
                }
            },
            //St Upper highlight outline
            {
                id: `${_config.enums.LEG_BODY.ST_UPPER}-highlight-outline`,
                type: 'line',
                'source': `${_config.enums.LEG_BODY.ST_UPPER}-choro-source`,
                //'source': `legislative-choro-source`,
                'source-layer': `statelegupper_demographics`,
                paint: {
                    'line-color': '#222',
                    'line-opacity': 1,
                    'line-width': 5
                },
                'layout': {
                    'visibility': 'visible',
                },
                //https://docs.mapbox.com/mapbox-gl-js/style-spec/expressions/
                //https://docs.mapbox.com/help/glossary/filter/
                "filter": ["==", ["get","geoid"], '#222'],
                'params':{
                    beforeId: 'choropleth-highlight-outline-placeholder',
                }
            },
            //st lower outline
            {
                id: `${_config.enums.LEG_BODY.ST_LOWER}-outline`,
                type: 'line',
                'source': `${_config.enums.LEG_BODY.ST_LOWER}-choro-source`,
                //'source': `legislative-choro-source`,
                'source-layer': `stateleglower_demographics`,
                paint: {
                    'line-color': '#fff', //492 707070  222
                    'line-opacity': 0.8, //1
                    'line-width': 1.25 //.5
                },
                'layout': {
                    'visibility': 'none',
                },
                'minzoom': 6,
                'params':{
                    beforeId: 'choropleth-outline-placeholder',
                }
            },
            //st lower highlight outline
            {
                id: `${_config.enums.LEG_BODY.ST_LOWER}-highlight-outline`,
                type: 'line',
                'source': `${_config.enums.LEG_BODY.ST_LOWER}-choro-source`,
                //'source': `legislative-choro-source`,
                'source-layer': `stateleglower_demographics`,
                paint: {
                    'line-color': '#222',
                    'line-opacity': 1,
                    'line-width': 5
                },
                'layout': {
                    'visibility': 'visible',
                },
                //https://docs.mapbox.com/mapbox-gl-js/style-spec/expressions/
                //https://docs.mapbox.com/help/glossary/filter/
                "filter": ["==", ["get","geoid"], '#222'],
                'params':{
                    beforeId: 'choropleth-highlight-outline-placeholder',
                }
            },
        ]
    }
}